var _circle, _path, _path2, _circle2, _circle3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _path16, _path17, _path18, _rect16, _rect17, _rect18, _rect19, _rect20, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSamsTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 224,
    viewBox: "0 0 225 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 112.292,
    cy: 112,
    r: 112,
    fill: "#89D0FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M127.683 1.04881C136.049 8.72619 141.293 19.7507 141.293 32C141.293 55.196 122.488 74 99.2925 74H12.2925C10.5075 74 8.7486 73.8886 7.02222 73.6725C22.6746 30.6921 63.8993 0 112.293 0C117.514 0 122.652 0.357308 127.683 1.04881Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M223.751 100.918C216.099 108.976 205.282 114 193.292 114H106.292C83.0965 114 64.2925 95.196 64.2925 72C64.2925 48.804 83.0965 30 106.292 30H188.582C208.014 48.0869 221.009 72.9981 223.751 100.918Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.03,
    cy: 140.229,
    r: 14.918,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.5545,
    cy: 140.229,
    r: 14.918,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2925 111.315H192.538L194.833 118.233V138.064C194.833 140.482 192.872 142.442 190.454 142.442H31.6712C29.2529 142.442 27.2925 140.482 27.2925 138.064V111.315Z",
    fill: "#C81920"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2925 118.426V134.492H194.833V118.426H27.2925Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.799 142.442H112.342C112.255 141.717 112.21 140.978 112.21 140.229C112.21 130.089 120.431 121.869 130.571 121.869C140.711 121.869 148.931 130.089 148.931 140.229C148.931 140.978 148.887 141.717 148.799 142.442Z",
    fill: "#C81920"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7669 142.442H34.3098C34.2226 141.717 34.1777 140.978 34.1777 140.229C34.1777 130.089 42.398 121.869 52.5383 121.869C62.6786 121.869 70.8989 130.089 70.8989 140.229C70.8989 140.978 70.8541 141.717 70.7669 142.442Z",
    fill: "#C81920"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.669 118.426V111.541H192.538L197.128 118.426L195.21 138.561C194.996 140.808 193.109 142.524 190.851 142.524H150.079V118.426H154.669Z",
    fill: "#C7C8CB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M150.079 134.492V142.524H190.851C193.109 142.524 194.996 140.808 195.21 138.561L195.598 134.492H150.079Z",
    fill: "#909196"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M195.598 134.492L195.21 138.561C194.996 140.808 193.109 142.524 190.851 142.524H155.817V134.492H195.598Z",
    fill: "#686A70"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.8762 85.8798C96.0303 84.8012 96.9541 84 98.0436 84H145.914C147.731 84 149.359 85.1221 150.006 86.8199L158.112 108.098H92.7021L95.8762 85.8798Z",
    fill: "#C81920"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.538 86.295H144.118C145.993 86.295 147.66 87.4888 148.264 89.264L154.669 108.098H129.423L122.538 86.295Z",
    fill: "#66AAEA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.735 86.295H115.43C117.305 86.295 118.972 87.4888 119.575 89.264L125.981 108.098H98.4397L100.735 86.295Z",
    fill: "#99C6F1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.079 111.541H192.538L197.128 118.426H154.669L150.079 111.541Z",
    fill: "#9B1419"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.079 84.9728H192.538L172.001 108.078H129.542L150.079 84.9728Z",
    fill: "#9B1419"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.079 84.9728H192.538L197.128 91.8581H154.669L150.079 84.9728Z",
    fill: "#C81920"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 164.997,
    y: 120.721,
    width: 19.5081,
    height: 1.14754,
    fill: "#7C7C7C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 164.997,
    y: 120.721,
    width: 1.14754,
    height: 10.3278,
    fill: "#7C7C7C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 169.587,
    y: 120.721,
    width: 1.14754,
    height: 10.3278,
    fill: "#7C7C7C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 173.03,
    y: 120.721,
    width: 1.14754,
    height: 10.3278,
    fill: "#7C7C7C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 176.472,
    y: 120.721,
    width: 1.14754,
    height: 10.3278,
    fill: "#7C7C7C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 179.915,
    y: 120.721,
    width: 1.14754,
    height: 10.3278,
    fill: "#7C7C7C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 184.505,
    y: 120.721,
    width: 1.14754,
    height: 10.3278,
    fill: "#7C7C7C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 164.997,
    y: 123.016,
    width: 19.5081,
    height: 1.14754,
    fill: "#7C7C7C"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 164.997,
    y: 125.311,
    width: 19.5081,
    height: 1.14754,
    fill: "#7C7C7C"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 164.997,
    y: 127.606,
    width: 19.5081,
    height: 1.14754,
    fill: "#7C7C7C"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 164.997,
    y: 129.901,
    width: 19.5081,
    height: 1.14754,
    fill: "#7C7C7C"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 155.817,
    y: 120.721,
    width: 8.03276,
    height: 8.03276,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 8.03276,
    height: 3.44261,
    transform: "matrix(1 0 0 -1 155.817 132.197)",
    fill: "#FB741A"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 186.8,
    y: 120.721,
    width: 8.03276,
    height: 8.03276,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 8.03276,
    height: 3.44261,
    transform: "matrix(1 0 0 -1 186.8 132.197)",
    fill: "#FB741A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5383,
    cy: 140.229,
    r: 14.918,
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5383,
    cy: 140.229,
    r: 10.3278,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5383,
    cy: 140.229,
    r: 6.88522,
    fill: "#6D7278"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5383,
    cy: 140.229,
    r: 14.918,
    fill: "black"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.571,
    cy: 140.229,
    r: 14.918,
    fill: "black"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5383,
    cy: 140.229,
    r: 10.3278,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.571,
    cy: 140.229,
    r: 10.3278,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5383,
    cy: 140.229,
    r: 6.88522,
    fill: "#9E9FA3"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.571,
    cy: 140.229,
    r: 6.88522,
    fill: "#9E9FA3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.7021 108.098H190.243L192.538 111.541H92.7021V108.098Z",
    fill: "#C81920"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.939 109.086C29.3438 108.469 30.0316 108.098 30.7689 108.098H92.7021V111.592H27.2925L28.939 109.086Z",
    fill: "#E54950"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.079 108.098H189.071C189.803 108.098 190.487 108.464 190.893 109.073L192.538 111.541H150.079V108.098Z",
    fill: "#C81920"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 99.5874,
    y: 114.984,
    width: 8.03276,
    height: 2.29507,
    rx: 1.09469,
    fill: "#D8D8D8"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 114.505,
    y: 100.065,
    width: 6.88522,
    height: 11.4754,
    rx: 1.09469,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 145.491,
    y: 105.889,
    width: 14.3492,
    height: 2.18887,
    fill: "#BABBBE"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 146.464,
    y: 104.673,
    width: 2.67528,
    height: 1.21604,
    fill: "#FFC220"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 155.949,
    y: 104.673,
    width: 2.67528,
    height: 1.21604,
    fill: "#FFC220"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6969 215.198C41.5338 203.709 19.8464 181.809 8.63745 154.5H215.947C215.81 154.834 215.671 155.168 215.531 155.5C198.551 195.749 158.721 224 112.292 224",
    fill: "#9B9B9B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M112.292 224C96.8285 224 82.0964 220.866 68.6969 215.198L112.292 224Z",
    fill: "#9B9B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamsTruck);
export default __webpack_public_path__ + "static/media/samsTruck.822f956d9bf379e5e50a2957fa672efe.svg";
export { ForwardRef as ReactComponent };